'use client';

import { forwardRef, useCallback } from 'react';
import type { NumberFormatBaseProps } from 'react-number-format';
import { PatternFormat } from 'react-number-format';
import { TextField } from '@kcd/design-system';

type TextFieldProps = Omit<
  React.ComponentProps<typeof TextField>,
  'ref' | 'type'
>;

type Props = {
  onChange?: (value: string) => void;
  className?: string;
} & TextFieldProps &
  Omit<
    NumberFormatBaseProps,
    'customInput' | 'format' | 'type' | 'prefix' | 'suffix'
  >;

export const MaskedNumberField = forwardRef(function MaskedNumberField(
  { onChange, suffix, prefix, ...props }: Props,
  ref: React.Ref<HTMLInputElement>,
) {
  const CustomInput = useCallback(
    (customInputProps: TextFieldProps) => (
      <TextField {...customInputProps} ref={ref} />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [prefix, suffix],
  );

  return (
    <PatternFormat
      {...props}
      type="tel"
      format="### #### ####"
      isAllowed={({ value }) =>
        /^$|^0$|^01$|^01[016789]$|01[016789]\d{0,8}/.test(value)
      }
      onValueChange={({ value }) => onChange?.(value)}
      customInput={CustomInput}
    />
  );
});
